/**
 * Component Registry for Park at Ferentino
 *
 * Inherits from @vibesites-amc/theme-preferred and allows property-specific overrides.
 */

import type { ComponentRegistry } from '@vibesites/runtime';
import { registry as parentRegistry } from '@vibesites-amc/theme-preferred/registry';
import { Gallery } from './components/Gallery';

/**
 * Property-specific component overrides.
 */
const propertyOverrides: Partial<ComponentRegistry> = {
  Gallery,
};

/**
 * Final merged registry for this property.
 * Inherits all components from the parent theme, with property overrides.
 */
export const registry: ComponentRegistry = {
  ...parentRegistry,
  ...propertyOverrides,
};

export default registry;
